import { render, staticRenderFns } from "./sidebar_navigation.vue?vue&type=template&id=3c16a42d"
import script from "./sidebar_navigation.vue?vue&type=script&lang=js"
export * from "./sidebar_navigation.vue?vue&type=script&lang=js"
import style0 from "./sidebar_navigation.vue?vue&type=style&index=0&id=3c16a42d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports